import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AnimationOptions } from 'ngx-lottie';
import { ChartTheme } from '@nimbus-library/features/charts/models/char-theme.enum';
import { SpinnerService } from '@nimbus-library/features/shared/services/spinner.service';

@Component({
  standalone: false,
  selector: 'nimbus-spinner',
  styleUrls: ['./spinner.component.scss'],
  templateUrl: './spinner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent implements OnInit {
  @Input() public small = true;
  @Input() public height: number;
  @Input() public theme: ChartTheme;
  @Input()
  @HostBinding('class.transparent')
  public transparent = false;
  @Input()
  @HostBinding('class.absolute')
  public absolute = true;
  @Input()
  @HostBinding('class.translucent')
  public translucent = false;

  public get options(): Observable<AnimationOptions> {
    return this.spinnerService.getSpinner$(this.small).pipe(
      map((animationData) => ({
        animationData,
      })),
    );
  }

  public constructor(private readonly spinnerService: SpinnerService) {}

  public ngOnInit(): void {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    this.height = this.height || (this.small ? 14 : 70);
  }
}
